/**
 * UploadFlow — the full-page route at `/upload?zone=X`.
 *
 * Phase 2.8 refactor: the 4-step upload UI was extracted into
 * `<UploadFlowSteps>` so it can be shared between this route and the new
 * `<UploadModal>` (which mounts the same steps over the home scene). This
 * page now only owns:
 *
 *   - the `bg-pop-night` chrome and page header,
 *   - the "Zpět" link back to `/`,
 *   - the navigation decision on confirm (`/contract/:id`).
 *
 * Step state, OCR mutation, and per-step rendering live inside the shared
 * component. See its docstring + `Design-Specs/Upload-Flow.md` on the wiki.
 *
 * Direct-URL access (e.g. `/upload?zone=vehicle`) keeps working — the wiki
 * QA script still uses the page form as a fallback for the demo.
 */
import { Link, useNavigate, useSearchParams } from 'react-router-dom'

import {
  UploadFlowSteps,
  type UploadZone,
} from '@/components/UploadFlowSteps'

const VALID_ZONES: ReadonlySet<UploadZone> = new Set([
  'house',
  'vehicle',
  'travel',
  'life',
])

export default function UploadFlow() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const rawZone = params.get('zone')
  const zone: UploadZone =
    rawZone && VALID_ZONES.has(rawZone as UploadZone)
      ? (rawZone as UploadZone)
      : 'house'

  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-4 py-10 bg-pop-night text-pop-cream">
      <Link to="/" className="pixel-btn-secondary absolute top-6 left-6 text-xs">
        ← Zpět
      </Link>

      <UploadFlowSteps
        zone={zone}
        onConfirm={(result) => navigate(`/contract/${result.contract.id}`)}
        onCancel={() => navigate('/')}
        confirmLabel="Pokračovat"
      />
    </main>
  )
}
